import styled from 'styled-components';

export const ContainerMessage = styled.section`
  display: flex;
  align-items: flex-start;
  color: #707070;
  margin-bottom: 20px;

  ul {
    list-style: none;
  }
`;

export const Activity = styled.div`
  header {
    .name {
      font-family: 'Poppins-Medium' Arial, Helvetica, sans-serif;
      font-size: 15px;
      margin-bottom: 3px;
    }

    .date {
      display: inline-block;
      font-family: Poppins Arial, Helvetica, sans-serif;
      font-size: 10px;
      margin-left: 5px;
    }
  }

  main {
    font-family: Poppins Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 1.5em;
  }
`;
